/* global Stripe, stripePublicKey */

import "jquery";

let stripe;
let card;
let locale = window.location.href.includes('/fr') ? 'fr' : 'en';

$(document).ready(function () {

  if (document.getElementById('paymentForm') === null) {
    return;
  }
  if(stripePublicKey.publicKey !== 'pkx'){
  
    stripe = Stripe(stripePublicKey.publicKey);
  
    const elements = stripe.elements({locale: locale});

    card = elements.create('card', {
      hidePostalCode: true,    
    });

    card.mount('#stripe-card-element');

    card.on('change', function(event) {
      const displayError = document.getElementById('card-errors');

      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });


    $('#paymentForm').submit(function(event) {

      event.preventDefault();
      // reCaptcha
      if(document.getElementById("g-recaptcha-response") !== null){
        if($('#g-recaptcha-response').val().length == 0) {
          var xMark = '\u2718';
          var text = 'reCaptcha is invalid';
          this.feedback = document.getElementById('form-error-reCaptcha');
          if(getLanguage() == 'fr') {
            text = 'reCaptcha invalide';
          }
          this.feedback.innerHTML = xMark + ' ' + text;
          this.feedback.classList.add('error');
          this.toggleProcessingScreen();
          return false;
          }
      }


        $('#pay-button').prop('disabled', true);
        $('#processing-screen').addClass('visible');


        stripe.createPaymentMethod({
          type: 'card',
          card: card,
          billing_details: {
            name: $('#ordName').val(),
            email: $('#ordEmailAddress').val(),
            phone: $('#ordPhoneNumber').val(),
            address: {
              line1: $('#ordAddress1').val(),
              line2: $('#ordAddress2').val(),
              city: $('#ordCity').val(),
              state: $('#ordProvince').val(),
              postal_code: $('#ordPostalCode').val(),
              country: 'CA',
            },
          },
        }).then(function(result) {

          if (result.error) {

            $('#card-errors').text(result.error.message);

            $('#pay-button').prop('disabled', false);
            $('#processing-screen').removeClass('visible');

            return;

          }

          processStripePayment(result.paymentMethod.id);

        });

      });      

  }
});


function processStripePayment(paymentMethodId) {
  $.post('/wp-admin/admin-ajax.php?action=validate_recaptcha', {
    data: jQuery('#paymentForm').serialize(),
    }, function(result) {
      if(result == 'true'){
        $.post('/wp-admin/admin-ajax.php?action=stripe_process', {

          amount: $('#trnAmount').val(),

          payment_method: paymentMethodId,

          invoice_number: $('#trnInvoiceNumber').val(),

          billing: {
            name: $('#ordName').val(),
            address_line1: $('#ordAddress1').val(),
            address_line2: $('#ordAddress2').val(),
            city: $('#ordCity').val(),
            province: $('#ordProvince').val(),
            country: 'CA',
            postal_code: $('#ordPostalCode').val(),
            phone_number: $('#ordPhoneNumber').val(),
            email_address: $('#ordEmailAddress').val(),
          },

          account: $('#account').val(),
          
          custom: {
          //  ref1: $('#ref1').val(),
            ref2: $('#ref2').val(),
            ref3: $('#ref3').val(),
            ref4: $('#ref4').val(),
            ref5: $('#ref5').prop("checked"),
          },

          comments: $('#comments').length > 0 ? $('#comments').val() : null,

          payment_type: $('input[name="payment-type"]:checked').val(),

          store: $('#paymentStore').val(),

        }, function(result) {

          result = JSON.parse(result);    
          window.location.href = result.redirect;

        });
      } else {
        $('#form-errors').html('Sorry, the captcha could not be validated');
        $('#pay-button').disabled = false;
        document.getElementById('processing-screen').classList.toggle('visible');
        $('#form-errors').css('display','block');
      }
    }
  );
}

function getLanguage(){
  return document.documentElement.lang.split('-')[0];
}

function reCaptchaCallback(){
  var target = document.getElementById('form-error-reCaptcha');
  target.innerHTML = '';
  document.getElementById('pay-button').disabled = false;
}
window.reCaptchaCallback = reCaptchaCallback;
